import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { deepPurple } from '@mui/material/colors';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { fr } from 'date-fns/locale/fr';
import { onAuthStateChanged } from 'firebase/auth';
import { useEffect, useState } from 'react';

import { ApolloProvider } from './apollo/Apollo.provider';
import { firebaseAuth } from './firebase/firebase.service';
import { RootNavigator } from './navigation/RootNavigator';
import { LayoutContextProvider } from './navigation/components/Layout/LayoutContext';
import { ToastProvider } from './toast/Toast.provider';

const defaultTheme = createTheme({
  palette: {
    secondary: deepPurple,
  },
});

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean | undefined>(undefined);
  useEffect(() => {
    return onAuthStateChanged(firebaseAuth, (user) => {
      setIsLoggedIn(user !== null);
    });
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
      <LayoutContextProvider>
        <ToastProvider>
          <ApolloProvider>
            <ThemeProvider theme={defaultTheme}>
              <CssBaseline />
              {isLoggedIn !== undefined ? (
                <RootNavigator isLoggedIn={isLoggedIn} />
              ) : null}
            </ThemeProvider>
          </ApolloProvider>
        </ToastProvider>
      </LayoutContextProvider>
    </LocalizationProvider>
  );
}

export default App;
